import { useState, useEffect } from 'react';

export const useConfigRegister = (open: boolean, error: boolean, update: any, origin: string) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [isUpdate, setIsUpdate] = useState<boolean>(false);
    const [fieldName, setFieldName] = useState('field_expired');
    const [updateCount, setUpdateCount] = useState({accumulators: 0, [fieldName]: 0});
    const [form, setForm] = useState({
		channel: '',
		operation: '',
		accumulators: [],
		// reboots: []
	})

	const [errors, setErrors] = useState({
		channel: false,
		operation: false,
		accumulators: [],
		// reboots: []
	})
	errors[fieldName] = []

	const accumulators = {
		name: '', description: '', value: ''
	}
	const field_expired = {
		path: '', value: 0, expired_date: '', delta_expired: 3600, evaluate: true
	}
	// const reboots = {
	// 	name: '', expired_date: '', delta_expired: 3600, evaluate: true
	// }
	const [dataType, setDataType ] = useState([])

	const catalogType = [
		{key: 'gender', catalog: true, label: 'Género'},
		{key: 'country', catalog: true, label: 'Nacionalidad'},
		{key: 'occupations', catalog: true, label: 'Ocupación'},
		{key: 'economicActivities', catalog: true, label: 'Actividad Económica'},
		{key: 'customerOrigin', catalog: true, label: 'Origen'},
		{key: 'datetime-local', catalog: false, label: 'Fecha'},
		{key: 'boolean', catalog: false, label: 'Boolean'},
		{key: 'number', catalog: false, label: 'Número'},
		{key: 'text', catalog: false, label: 'Texto'},
	]

	const onHandleType = (key=0, e) => {
		let d = dataType
		let val = catalogType.filter((item) => {
			return item['key'] === e.target.value;
		})[0]

		if(dataType[key]?.index === key && form.accumulators[key] && form.accumulators[key].value){
			d[key] = {index: key, key: val.key, catalog: val.catalog, label: val.label}
			setDataType(JSON.parse(JSON.stringify(d)));
			let e = {target:{value: null}}
			onHandleChange('accumulators', 'value', key, e)
		} else if(dataType[key]?.index === key){
			d[key] = {index: key, key: val.key, catalog: val.catalog, label: val.label}
			setDataType(JSON.parse(JSON.stringify(d)));
		} else {
			setDataType(dataType => ([...dataType,  {index: key, key: val.key, catalog: val.catalog, label: val.label}]));
		}
	}

	const onHandleChange = (nodo, field, key, e) => {
		let value = e.target.value
		let f = form

		if(nodo){
			let copy = null
			if(origin === 'accumulator' && field.includes('date') && nodo === 'accumulators'){
				copy = field
				field = 'date'
			}
			switch (nodo+'|'+field) {
				case 'accumulators|value':
				case 'accumulators|date':
					if(dataType[key || 0].key === 'number'){
						value = Number(value)
					}
					if(dataType[key || 0].key === 'boolean'){
						value = Boolean(value)
					}
					if(dataType[key || 0].key === 'datetime-local'){
						value = value.concat(':00Z')
						if(copy){
							field = copy
						}
						break
					}			
					break;
				case 'field_expired|evaluate':
				case 'fields_expired|evaluate':
				// case 'reboots|evaluate':
					if(value === 'on'){
						value = e.target.checked
					}
					break;
				case 'field_expired|expired_date':
				case 'fields_expired|expired_date':
				// case 'reboots|expired_date':
					value = value.concat(':00Z')
					break;
				case 'field_expired|delta_expired':
				case 'fields_expired|delta_expired':
				// case 'reboots|delta_expired':
					value = Number(value)
					break;
			
				default:
					break;
			}

			if(key !== undefined){
				origin === 'accumulator' && nodo === 'accumulators' ?
				f[nodo][field] = value
				: f[nodo][key][field] = value
			} else {
				switch (nodo) {
					case 'accumulators':
						let a = accumulators
						a[field] = value
						f[nodo].push(a)	
						break;
					case 'field_expired':
						let fe = field_expired
						fe[field] = value
						f[nodo].push(fe)	
						break;
					// case 'reboots':
					// 	let r = reboots
					// 	r[field] = value
					// 	f[nodo].push(r)	
					// 	break;				
					default:
						break;
				}
			}
		} else {
			f[field] = value
		}
		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
	}
	
	const validateForm = (f, nodo=null, k=null) => {
		let e = errors
		Object.keys(f).forEach( val => {
            if(Array.isArray(f[val])){
				f[val].map((item, key) => {
					return validateForm(item, val, key)
				})
            } else {
                const validate = (bool) => {
                    e[val] = bool
                }
                const validateEvents = (bool) => {
                    if(e[nodo] && e[nodo][k]){
                        e[nodo][k] = {...e[nodo][k], [val]: bool}
                    } else {
                        e[nodo]?.length > 0 ?  e[nodo] = e[nodo].concat({[val]: bool}) : e[nodo] = [{[val]: bool}]
                    }
                }
                if(f[val] || f[val] === 0){
					nodo ? validateEvents(false) : validate(false)
				} else {
                    nodo ? validateEvents(true) : validate(true)
                }
            }
        })

        setErrors(JSON.parse(JSON.stringify(e)));
		checkError(e)
	};

	const checkError = (e) => {
		let found = true;
        for(var i = 0; i < Object.values(e).length; i++) {
            let check = (item) => {
                if(Object.values(item)?.includes(true)){
                   return true;
                }
            }
            if (Array.isArray(Object.values(e)[i])) {
                var values : any = Object.values(e)[i];
		        // eslint-disable-next-line
                values.map((item) => check(item) ? found = false : null);

            } else if (typeof(Object.values(e)[i]) === 'object') {
                if(check(Object.values(e)[i])){
                    found = false;
                    break;
                } 
            } else if(Object.values(e)[i]){
                found = false;
                break;
            }
        }

		setIsValidForm(!found);
	}

	const onAddItem = (item) => {
		let f = form
		switch (item) {
			case 'accumulators':
				f[item].push(accumulators)
				break;
			case 'field_expired':
			case 'fields_expired':
				f[item].push(field_expired)
				break;
			// case 'reboots':
			// 	f[item].push(reboots)
			// 	break;		
			default:
				break;
		}
		setForm(JSON.parse(JSON.stringify(f)));
	}

	const onDeleteItem = (nodo, key) => {
		let f = form
		f[nodo].splice(key, 1)
		setForm(JSON.parse(JSON.stringify(f)));

		let e = errors
		if(e[nodo] && e[nodo][key]){
			e[nodo].splice(key, 1)
		}
		setErrors(JSON.parse(JSON.stringify(e)));

		let d = dataType
		d.splice(key, 1)
		setDataType(JSON.parse(JSON.stringify(d)));

		validateForm(f)
	}

	const generateCatalog = (data, bool) => {
		let newCatalog = []
		const getNoCatalog = (item, i) => {
			switch(typeof(bool ? item : item.value)){
				case 'number':
					return newCatalog.push({key: 'number', catalog: false, label: 'Número', index: i})
				case 'boolean':
					return newCatalog.push({key: 'boolean', catalog: false, label: 'Booleano', index: i})
				default:
					if(bool ? item.includes('date') : item.name.includes('date')){
						return newCatalog.push({key: 'datetime-local', catalog: false, label: 'Fecha', index: i})
					} else {
						return newCatalog.push({key: 'text', catalog: false, label: 'Texto', index: i})
					}
			}
		}

		let type = bool ? Object.keys(data) : data
		type.map((item, i) => {
			switch(bool ? item : item.name){
				case 'source_general_gender':
					return newCatalog.push({key: 'gender', catalog: true, label: 'Género', index: i})
				case 'source_general_nationality':
					return newCatalog.push({key: 'country', catalog: true, label: 'Nacionalidad', index: i})
				case 'source_general_occupation':
					if(!bool){
						let corp = data.filter((i) => i.name === 'is_corp')[0]
						return newCatalog.push({key: corp.value === 0 ? 'occupations' : 'economicActivities', catalog: true, label: corp.value === 0 ? 'Ocupación' : 'Actividad económica', index: i})
					} else {
						return getNoCatalog(item, i)
					}
				case 'is_corp':
					return newCatalog.push({key: 'customerOrigin', catalog: true, label: 'Origen', index: i})
				default:
					return getNoCatalog(item, i)
			}
		})

		setDataType(newCatalog)
	}

	useEffect(() => {
		if(open && !error && !update){
			setIsUpdate(false)
			setForm({
				channel: '',
				operation: '',
				accumulators: [],
				// reboots: []
			})
			setErrors({
				channel: false,
				operation: false,
				accumulators: [],
				// reboots: []
			})
			setDataType([])
		}
		if(open && !error && update && origin === 'accumulator'){
			setIsUpdate(true)
			generateCatalog(update.accumulators, true)
			setForm(JSON.parse(JSON.stringify(update)));
			setUpdateCount({accumulators: update.accumulators?.length, fields_expired: update.fields_expired?.length})
			setFieldName('fields_expired')
		} else if(open && !error && update){
			setIsUpdate(true)
			generateCatalog(update.accumulators, false)
			setForm(JSON.parse(JSON.stringify(update)));
			setUpdateCount({accumulators: update.accumulators.length, field_expired: update.field_expired.length})
		}
    }, [open, error, update, origin])

    return { form, isValidForm, catalogType, dataType, isUpdate, updateCount, errors, fieldName, onAddItem, onDeleteItem, onHandleType, onHandleChange }
};
